import { Component, EventEmitter, Input, Output, ViewContainerRef } from '@angular/core';
import { TRANSACTION_CATEGORY_TYPE, Transaction } from '../../model/myria/app/transaction';
import { RouteProvider } from '../../providers/route/route';
import { SegmentProvider } from '../../providers/analytics/segment';
import { AnalyticsEventType, SegmentLocationNames } from '../../model/types/analytics.const';
import { PaymentMethodTypeID } from '../../model/types/payment-method-type';
import { OrderProvider } from '../../providers/order/order';
import { TransactionFilterType } from '../../model/types/transaction-filter-type';
import { SendFlowProvider } from '../../providers/send-flow/send-flow';
import { TranslateService } from '@ngx-translate/core';
import { LoginProvider } from '../../providers/myria/login-provider';
import { AuthProvider } from '../../providers/authorization';
import { UtilsProvider } from '../../providers/myria/utils-provider';
import { RegisterProvider } from '../../providers/register/register';
import { WalletProvider } from '../../providers/wallet/wallet';
import { HomeScreenProvider } from '../../providers/homescreen/homescreen';




@Component({
  selector: 'activity-menu-filter',
  templateUrl: 'activity-menu-filter.html'
})
export class ActivityMenuFilterComponent {

  @Input() allTransactions: Transaction[];
  @Input() newTransaction: Transaction;
  @Input() pendingOrder: Transaction;
  @Input() hasTransactions: boolean = false;
  @Input() showRecentView;
  @Input() selectTransactionCb: any;




  menuItems = ["page.activityPage.allButton", "page.activityPage.inStoreButton"];
  menuTitle: any;
  onlineTransactions: Transaction[] = [];
  inStoreTransactions: Transaction[] = [];
  menuSelected = TransactionFilterType.All;
  displaySuspectedAlert= false;
  showRightProfile: boolean;
  hasTransaction: boolean;
  transactionType;

  constructor(private routeProvider: RouteProvider,
    private analytics: SegmentProvider,
    private utilsProvider: UtilsProvider,
    private orderProvider: OrderProvider,
    private sendFlowProvider: SendFlowProvider,
    private translate: TranslateService,
    private loginProvider: LoginProvider,
    private authProvider: AuthProvider,
    private registerProvider: RegisterProvider,
    private walletProvider: WalletProvider,
    private homeScreenProvider: HomeScreenProvider) {
      if (this.homeScreenProvider.getCatchedMenuTitle()) {
        this.setMenuTitle(this.homeScreenProvider.getCatchedMenuTitle());
      }
    }

  ngOnChanges() {
    this.filterTransactions();
    this.assignTransactionType();
    this.checkForTransactions(); 
  }

  onSelectTransaction(transaction: Transaction, index = null) {
    this.walletProvider.selectTransaction(transaction, index);
  }


  setMenuTitle(event) {
    this.menuTitle = event;
    this.homeScreenProvider.setCachedMenuTitle(this.menuTitle);
    switch(this.menuTitle) {
      case "page.activityPage.onlineButton":
        this.menuSelected = TransactionFilterType.Online;
        break;
      case "page.activityPage.inStoreButton":
        this.menuSelected = TransactionFilterType.InStore;
        break;
      default:
        this.menuSelected = TransactionFilterType.All;
    }
    this.assignTransactionType();
    this.checkForTransactions();
  }

  getSelectedButton(): string {
    const cachedTitle = this.homeScreenProvider.getCatchedMenuTitle();
    return cachedTitle && this.menuItems.includes(cachedTitle) ? cachedTitle : this.menuItems[0];
  }

  filterTransactions() {
    const stagedTransactions = this.allTransactions.filter((element) => this.orderProvider.isStagedPaymentMethodById(element.PaymentMethod));
    const onlineTransactions = this.allTransactions.filter((element) => !this.orderProvider.isStagedPaymentMethodById(element.PaymentMethod));
    this.inStoreTransactions = stagedTransactions;
    this.onlineTransactions = onlineTransactions;
  }

  getFormattedDate(time) {
    const date = new Date(time);
    return this.utilsProvider.getFormattedActivityTransactionDate(date.toString());
  }


  assignTransactionType() {
    if(this.newTransaction) {
      const paymentMethod = this.newTransaction.PaymentMethod;
      if(this.menuSelected == TransactionFilterType.All) this.transactionType = TransactionFilterType.All;
      else if(this.orderProvider.isStagedPaymentMethodById(paymentMethod)) {
         this.transactionType = TransactionFilterType.InStore;
      }
      else {
         this.transactionType = TransactionFilterType.Online;
      }
    }
  }


    checkForTransactions() {
      // handle the case if we have new transaction, since we recieve that alone and it won't be in the transaction @Input object
      if(this.newTransaction && this.menuSelected == this.transactionType) {this.hasTransaction = true;}
      else if(this.menuSelected == TransactionFilterType.Online && this.onlineTransactions.length == 0
        || this.menuSelected == TransactionFilterType.InStore && this.inStoreTransactions.length == 0 ) {
        this.hasTransaction =  false;
      } else {
      this.hasTransaction = true;
      }
    }
}



// WEBPACK FOOTER //
// ./src/components/activity-menu-filter/activity-menu-filter.ts